import { render, staticRenderFns } from "./MaterialInfo.vue?vue&type=template&id=c5564ff6"
import script from "./MaterialInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialInfo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports